module.exports = __webpack_public_path__ + "static/media/arrow-next.3f50c803.svg";